module.exports = __webpack_public_path__ + "static/cennik-f53cb568714cfc00e76293215424873f.jpg";